<template>
  <div class="homepage-recommand-cruises" v-if="likeRoutePopupsList.length>0" :style="{'margin-bottom': isHomeShow ? '25px' : '0'}">
    <div v-if="type===1">
      <h2  class="cruise-title" v-if="isHomeShow">猜你喜欢</h2>
      <div  class="cruise-header" v-else-if="!isHomeShow">
        <div class="cruise-header-left">
          <div class="cruise-header-left-icon"><img src="https://resource.rcclchina.com.cn/wechatMiniProgram/questionnaire/icons/mb-recommend.svg" alt=""></div>
          猜你喜欢
        </div>
        <div class="cruise-header-right" @click="toAllRoute">
          查看全部
          <div class="cruise-header-right-icon"><img src="https://resource.rcclchina.com.cn/wechatMiniProgram/icon-arrow-right.png" alt=""></div>
        </div>
      </div>
    </div>
    <ul
        class="cruise-content cruise-comm">


      <li
          v-for="(item, index) in likeRoutePopupsList"
          :key="index"
          class="cruise_link"
          @click="
          onCruiseClick(
          $event,
            item.shipCode,
            item.sailDate,
            item.isRow,
						index
          )
        "
      >
        <div class="img-wrapper">
          <div class="img-wrapper-tag">{{item.customizeTag}}</div>
          <img :src="item.mobileImage" alt=""/>
          <!-- countdown -->
          <div v-if="item.tag && item.tag.length > 0" class="bg-tag">
            {{ item.tag }}
          </div>
        </div>
        <div class="cruise-intro">
          <div class="intro-title">
            {{ item.cruiseName }}
          </div>
          <div class="intro-shipName intro-comm">
            {{ item.shipCNName }}&nbsp;&nbsp;|&nbsp;{{ item.routeDays }}天{{ item.routeDays-1 }}晚
          </div>
          <div class="intro-dataTime intro-comm">{{ getSailDate(item) }}</div>
          <div class="intro-price" v-if="item.netAmount > 0">
            <span class="tag">￥ </span>
            <span class="num"> {{ item.netAmount.toFixed(0) }}</span
            >/人起(含税)
          </div>
          <div v-if="!isOutOfStock" class="old-price">￥{{ item.originalAmount.toFixed(0) }}/人起(含税)</div>
          <div v-if="item.netAmount <= 0" class="intro-comm">售罄</div>
        </div>
      </li>
    </ul>
    <div class="viewAllBtn" v-if="isHomeShow" @click="toAllRoute">
      <div class="viewAllBtn-main">查看全部</div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import api from "@/api";
import {gioAdsTracking} from "@/utilities/tools";

export default {
  name: "HomeRecommendCruise",
  components: {
  },
  props: {
    likeRoutePopupsList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isHomeShow:{
      type:Boolean
    },
    type:{
      type: Number,
      default: 1
    },
    isOutOfStock:{
      type:Boolean,
      default:false
    },
    stateroomType:{
      type:String,
      default:''
    },
    guestNumberCount:{
      default:''
    }
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  methods: {
    getCruiseItems(categoryId) {
      let cruiseItems = this.likeRoutePopupsList.filter(
          (item) => item.cruiseCategoryId == categoryId && item.cruiseViewModel
      );
      cruiseItems = _.orderBy(cruiseItems, "sortNumber", "desc");
      return cruiseItems;
    },
    onCruiseClick(e, shipCode, sailDate, isRow, index) {
      console.log(isRow)
      e.stopPropagation();
      sailDate = sailDate.split("T")[0];
      let url = isRow ? `${process.env.VUE_APP_TUI_URL}/Cruise/MobileCruiseDetail?sailDate=${sailDate}&shipCode=${shipCode}`
          : `${process.env.VUE_APP_BASE_URL}/Rccl.Cruise/CruiseDetail?sailDate=${sailDate}&shipCode=${shipCode}`;
      const eventObject = {
        "adsType": "ls",
        "lsCatOrder": this.currentIndex + 1,
        "lsItmOrder": index + 1,
        "desUrl": url
      }
      if(this.isOutOfStock){
        url+=`&hmsr=out_of_stock_customization&hmpl=${shipCode+sailDate.replace(/-/g, '')}&hmcu=${this.guestNumberCount}&hmkw=${this.stateroomType}`
      }
      console.log(url)
      gioAdsTracking(eventObject);
      // if (isRow) {
        window.open(url);
      // } else {
      //   this.$router.push({
      //     name: "CruiseDetail",
      //     query: {shipCode: shipCode, sailDate: sailDate},
      //   });
      // }
    },
    toAllRoute(){
      this.$router.push({
        path:'/Rccl.Cruise/CruiseSearch/Search'
      })
    },
    getCruiseName(item) {
      let cruiseName = item.cruiseRoute;
      if (cruiseName > 49) {
        cruiseName = cruiseName.substr(0, 49) + "..";
      }
      return cruiseName;
    },
    getRouteNight(item) {
      const sailDays = item.sailDays;
      return `${sailDays}天${sailDays - 1}晚`;
    },
    getSailDate(item) {
      let sailDateBegin = item.sailDateBegin.split(" (")[0];
      let sailDateEnd = item.sailDateEnd.split(" (")[0];
      return `${sailDateBegin} - ${sailDateEnd}`;
    },
    onCategoryClick(index) {
      this.currentIndex = index;
      const eventObject = {
        "adsType": "ls",
        "lsCatOrder": index + 1
      }
      gioAdsTracking(eventObject);
    },
    onWishListClick(e, cruise) {
      e.stopPropagation();
      if (cruise.isInWishList) {
        this.deleteWishList(cruise);
      } else {
        this.addWishList(cruise);
      }
    },
    async addWishList(cruise) {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加至心愿单", {
          confirmCallBack: () => {
            self.$router.push({
              name: "Login",
              query: {
                returnUrl: location.href,
              },
            });
          },
        });
        return;
      }
      const requestData = {
        userName: userToken,
        cruiseId: cruise.cruiseViewModel.cruiseId,
        source: "mobile",
      };
      this.$loading.show();
      const {success} = await api.cruise.addWishList(requestData);
      if (success) {
        cruise.isInWishList = true;
      }
      this.$loading.hide();
    },
    async deleteWishList(cruise) {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加至心愿单", {
          confirmCallBack: () => {
            self.$router.push({
              name: "Login",
              query: {
                returnUrl: location.href,
              },
            });
          },
        });
        return;
      }
      const requestData = {
        userName: userToken,
        cruiseId: cruise.cruiseViewModel.cruiseId,
        source: "mobile",
      };
      this.$loading.show();
      const {success} = await api.cruise.deleteWishList(requestData);
      if (success) {
        cruise.isInWishList = false;
      }
      this.$loading.hide();
    },
  },
  computed: {},
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: PingFang-SC, Microsoft YaHei, Helvetica;
  text-transform: uppercase;
}

img {
  display: block;
}

/*限时抢购*/
.homepage-recommand-cruises {
  //margin-bottom: 25px;
  /*padding-top: 31px;*/
}

.homepage-recommand-cruises .cruise-title {
  font-size: 23px;
  font-weight: bold;
  color: #282b2c;
  line-height: 62px;
  text-align: center;
}
.homepage-recommand-cruises .cruise-header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  margin-bottom: 10px;
  //margin-top: 16px;
}
.cruise-header .cruise-header-left{
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 15px;
  font-family: PingFang-SC-Heavy, PingFang-SC;
  font-weight: 800;
  color: #2F2F2F;
  line-height: 21px;
}
.cruise-header .cruise-header-left .cruise-header-left-icon{
  width: 17px;
   height: 17px;
   //background-color: #999999;
}
img{
  width: 100%;
  height: 100%;
}
 .cruise-header-right{
   height: 17px;
   font-size: 12px;
   font-family: PingFangSC-Regular, PingFang SC;
   font-weight: 400;
   color: #000000;
   line-height: 17px;
   display: flex;
   align-items: center;
   gap: 4px;
 }
.cruise-header-right-icon{
  width: 6px;
  height: 10px;
}
.homepage-recommand-cruises .cruise-comm {
  //width: 345px;
  padding: 0 12px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  overflow: auto;
  gap: 12px;
}

.homepage-recommand-cruises .cruise-comm::-webkit-scrollbar {
  display: none;
}

.homepage-recommand-cruises .cruise-nav {
  margin-bottom: 12px;
}

.homepage-recommand-cruises .cruise-nav li {
  width: 165px;
  height: 49px;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  line-height: 49px;
  border: 1px solid #d3dadd;
  margin-bottom: 8px;
  border-radius: 4px;
  //background-color: #fff;
  //box-shadow: 0px 6px 24px 0px rgba(0, 115, 187, 0.12);

  color: rgb(40, 43, 44);
}

.homepage-recommand-cruises .cruise-nav li.active {
  background-color: rgb(84, 163, 222);
  color: #fff;
}

.homepage-recommand-cruises .cruise-content {
  //box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
  //display: none;
  background-color: #fdfdfd;
}

.homepage-recommand-cruises .cruise-content.active {
  display: flex;
}

.homepage-recommand-cruises .cruise-content li {
  width: 168px;
  margin-bottom: 18px;
  //padding-left: 3px;
}

.homepage-recommand-cruises .cruise-content li .img-wrapper {
  position: relative;
}
.homepage-recommand-cruises .cruise-content li .img-wrapper .img-wrapper-tag{
  background: url("../../assets/likeTageBg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  width: 60px;
  height: 26px;
  left: -4px;
  top: 14px;
  font-size: 11px;
  line-height: 20px;
  text-align: center;
  z-index: 99;
  color: #FFFFFF;
}
img{
  width: 100%;
  height: 100%;
}

.cruise-content li .img-wrapper .bg-tag {
  position: absolute;
  top: 0;
  left: -3px;
  background: url("https://resource.rcclchina.com.cn/homePage/mobile/bg.png") no-repeat;
  width: 92px;
  height: 23px;
  font-size: 12px;
  font-weight: 400;
  line-height: 23px;
  text-align: center;
  color: #fff;
}

.cruise-content li .img-wrapper .img-soucang {
  position: absolute;
  right: 11px;
  top: 11px;
  width: 27px;
  height: 23px;
}

.homepage-recommand-cruises .cruise-content li img {
  width: 151px;
  height: 168px;
  display: block;
  border-radius: 8px 8px 0 0;
}
.cruise_link{
  box-shadow: 19px 10px 20px 0 rgba(0, 0, 0, 0.08);
  border-radius: 0 0 8px 8px;
}
.homepage-recommand-cruises .cruise-content li .cruise-intro {
  padding: 10px 8px;
  border-radius: 0 0 8px 8px;
  background-color: #fff;
}

.cruise-content li .cruise-intro .intro-title {
  font-size: 12px;
  height: 34px;
  font-weight: 600;
  color: #333333;
  line-height: 17px;
//line-height: 20px; text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.cruise-content li .cruise-intro .intro-comm {
  font-size: 10px;
  line-height: 16px;
  color: #a0a6a7;
}

.cruise-content li .cruise-intro .intro-price {
  font-size: 12px;
  color: #000000;
}

.cruise-content li .cruise-intro .intro-price .num {
  font-weight: bold;
  font-size: 20px;
  margin: 0 2px 0 -5px;
  color: #FE0000;
}

.cruise-content li .cruise-intro .intro-price .tag {
  font-weight: bold;
  margin-left: -4px;
  color: #FE0000;
}

.cruise-content li .cruise-intro .old-price {
  color: #BBBBBB;
  font-size: 10px;
  text-decoration: line-through;
  /* margin-left: 20rpx; */
}

.viewAllBtn {
  width: 100%;
  height: 44px;
  padding: 0 15px;
}

.viewAllBtn-main {
  border: 1px solid #1878BD;
  text-align: center;
  line-height: 44px;
  margin: 0 auto;
  color: #1078BA;
  font-size: 16px;
  font-family: PingFang-SC-Medium, PingFang-SC, sans-serif;
}
</style>
